module.exports = __webpack_public_path__ + "img/time.15a74a8a.svg";